import {
  PhoneIcon,
  CogIcon,
  ChartPieIcon,
  BellIcon,
  LinkIcon,
  Squares2X2Icon,
  QueueListIcon,
  ClipboardDocumentListIcon,
  QuestionMarkCircleIcon,
  TrophyIcon,
  ShieldCheckIcon,
  AdjustmentsHorizontalIcon,
  ClockIcon,
} from "@heroicons/react/24/outline";
import { Webhook } from "lucide-react";
import { NavigationItem } from "./types";

export const callIntelligenceNavigation: NavigationItem[] = [
  {
    name: "Dashboard",
    internalName: "call-intelligence-dashboard",
    href: "/calls",
    icon: Squares2X2Icon,
    permissions: [],
    current: false,
  },
  {
    name: "Leaderboards",
    internalName: "leaderboards",
    href: "/calls/leaderboards",
    icon: TrophyIcon,
    permissions: [],
    roles: [
      "ROLE_SUPER_ADMIN",
      "ROLE_ADMIN",
      "ROLE_SALES_MANAGER",
      "ROLE_SALES_REP",
    ],
    current: false,
  },
  {
    name: "Call Scores",
    internalName: "ai-call-scores",
    href: "/calls/scores",
    icon: ChartPieIcon,
    permissions: [],
    roles: ["ROLE_SUPER_ADMIN"],
    current: false,
  },
  {
    name: "Call Insights",
    internalName: "member-questions",
    href: "/calls/questions",
    icon: QuestionMarkCircleIcon,
    permissions: [],
    roles: ["ROLE_SUPER_ADMIN", "ROLE_ADMIN", "ROLE_SALES_MANAGER"],
    current: false,
  },
  {
    name: "Scheduled Reports",
    internalName: "scheduled-reports",
    href: "/calls/scheduled-reports",
    icon: ClockIcon,
    permissions: [],
    roles: ["ROLE_SUPER_ADMIN", "ROLE_ADMIN", "ROLE_SALES_MANAGER"],
    current: false,
  },
  {
    name: "Settings",
    internalName: "call-settings",
    href: "/calls/settings",
    icon: CogIcon,
    permissions: [],
    roles: ["ROLE_SUPER_ADMIN"],
    current: false,
    children: [
      {
        name: "Rubrics",
        internalName: "rubric-configuration",
        href: "/calls/settings/scoring",
        icon: CogIcon,
        permissions: [],
        roles: ["ROLE_SUPER_ADMIN"],
        current: false,
      },
      {
        name: "Assign Rubric",
        internalName: "rubric-assignments",
        href: "/calls/settings/scoring/rules",
        icon: ClipboardDocumentListIcon,
        permissions: [],
        roles: ["ROLE_SUPER_ADMIN"],
        current: false,
      },
      {
        name: "Notifications",
        internalName: "notifications",
        href: "/calls/settings/notifications",
        icon: BellIcon,
        permissions: [],
        roles: ["ROLE_SUPER_ADMIN"],
        current: false,
        children: [
          {
            name: "Assignments",
            internalName: "notification-assignments",
            href: "/calls/settings/notifications/assignments",
            icon: BellIcon,
            permissions: [],
            roles: ["ROLE_SUPER_ADMIN"],
            current: false,
          },
          {
            name: "Email Templates",
            internalName: "email-templates",
            href: "/calls/settings/notifications/templates",
            icon: BellIcon,
            permissions: [],
            roles: ["ROLE_SUPER_ADMIN"],
            current: false,
          },
        ],
      },
      {
        name: "View Permissions",
        internalName: "view-permissions",
        href: "/calls/settings/permissions",
        icon: ShieldCheckIcon,
        permissions: [],
        roles: ["ROLE_SUPER_ADMIN"],
        current: false,
      },
      {
        name: "Global Settings",
        internalName: "global-call-settings",
        href: "/calls/settings/global",
        icon: AdjustmentsHorizontalIcon,
        permissions: [],
        roles: ["ROLE_SUPER_ADMIN"],
        current: false,
      },
      {
        name: "Queue Monitor",
        internalName: "queue-monitor",
        href: "/calls/transcriptions",
        icon: QueueListIcon,
        permissions: [],
        roles: ["ROLE_SUPER_ADMIN"],
        current: false,
      },
      {
        name: "Webhook Logs",
        internalName: "webhook-logs",
        href: "/calls/settings/webhooks",
        icon: Webhook,
        permissions: [],
        roles: ["ROLE_SUPER_ADMIN"],
        current: false,
      },
      {
        name: "Integrations",
        internalName: "integrations",
        href: "/calls/settings/integrations",
        icon: LinkIcon,
        permissions: [],
        roles: ["ROLE_SUPER_ADMIN"],
        current: false,
        children: [
          {
            name: "Zoom",
            internalName: "zoom-integration",
            href: "/calls/settings/integrations/zoom",
            icon: LinkIcon,
            permissions: [],
            roles: ["ROLE_SUPER_ADMIN"],
            current: false,
          },
          {
            name: "Fathom",
            internalName: "fathom-integration",
            href: "/calls/settings/integrations/fathom",
            icon: LinkIcon,
            permissions: [],
            roles: ["ROLE_SUPER_ADMIN"],
            current: false,
          },
          {
            name: "API Keys",
            internalName: "api-keys",
            href: "/calls/settings/integrations/api-keys",
            icon: LinkIcon,
            permissions: [],
            roles: ["ROLE_SUPER_ADMIN"],
            current: false,
          },
        ],
      },
    ],
  },
];

// Main menu item for the global navigation
export const callIntelligenceMainMenuItem: NavigationItem = {
  name: "Call Intelligence",
  internalName: "call-intelligence",
  href: "/calls",
  icon: PhoneIcon,
  permissions: [],
  current: false,
  children: callIntelligenceNavigation,
};

// Default export for unified navigation
export default {
  navigation: callIntelligenceNavigation,
  mainMenuItem: callIntelligenceMainMenuItem,
};
